import { Component, Input, OnInit } from '@angular/core';
import { IGalleryConfig, IGalleryItem } from 'src/app/commons/interfaces/gallery-config.interface';

@Component({
  selector: 'pda-gallery',
  templateUrl: './gallery.component.html',
  styleUrls: ['./gallery.component.scss']
})
export class GalleryComponent implements OnInit {

  @Input() config: IGalleryConfig;

  currentImage: string;
  description: string;
  title: string;

  constructor() { }

  ngOnInit(): void {
    this.currentImage = this.config.defaultImage;
    this.description = '';
    this.title = '';
  }

  selectItem(item: IGalleryItem): void {
    this.currentImage = item.path;
    this.description = item.description;
    this.title = item.title;
  }
}
